import { useFormik, useFormikContext } from "formik";
import React from "react";
import ErrorMessage from "../ErrorrMessage";
import textFieldStyles from "../TextField/TextField.module.css";
import styles from "./File.module.css";
import { labelName } from "../../../utils";

export default function File({
  field_label,
  displayLabel,
  allowed_types,
  file_size,
  parent,
  isRequired,
}) {
  const { setFieldValue, values } = useFormikContext();
  const name = parent ? `${parent}.fields.${field_label}` : field_label;

  const fieldValue = parent ? values?.[parent]?.fields?.[field_label] : values?.[field_label];
  const files = Array.isArray(fieldValue) ? fieldValue.map((file) => file.name) : [];

  if(allowed_types && typeof allowed_types == 'string'){
    allowed_types = JSON.parse(allowed_types)
  }

  const allowed =
    allowed_types && allowed_types.map((item) => `.${item.value}`).join(', ');

  const handleChange = (e) => {
    const selectedFiles = e.target.files;
    const fileList = Array.from(selectedFiles);
    setFieldValue(name, fileList); // Set array of files in formik field value
  };

  return (
    <div className={`${textFieldStyles.inputContainer}`}>
      <div className={`${textFieldStyles.fileContainer}`}>
        <label className={textFieldStyles.label}>{labelName(displayLabel || field_label)}</label>
        <label htmlFor={btoa("upload-photo-" + name)} className={styles.label}>
          <svg
            width="18px"
            fill={'#ACB5BD'}
            height="18px"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
            style={{ marginRight: '8px' }}
          >
            <path d="M5.602 19.8c-1.293 0-2.504-.555-3.378-1.44-1.695-1.716-2.167-4.711.209-7.116l9.748-9.87c.988-1 2.245-1.387 3.448-1.06 1.183.32 2.151 1.301 2.468 2.498.322 1.22-.059 2.493-1.046 3.493l-9.323 9.44c-.532.539-1.134.858-1.738.922-.599.064-1.17-.13-1.57-.535-.724-.736-.828-2.117.378-3.337l6.548-6.63c.269-.272.705-.272.974 0s.269.714 0 .986l-6.549 6.631c-.566.572-.618 1.119-.377 1.364.106.106.266.155.451.134.283-.029.606-.216.909-.521l9.323-9.439c.64-.648.885-1.41.69-2.145a2.162 2.162 0 0 0-1.493-1.513c-.726-.197-1.48.052-2.12.7l-9.748 9.87c-1.816 1.839-1.381 3.956-.209 5.143 1.173 1.187 3.262 1.629 5.079-.212l9.748-9.87a.683.683 0 0 1 .974 0 .704.704 0 0 1 0 .987L9.25 18.15c-1.149 1.162-2.436 1.65-3.648 1.65z" />
          </svg>
          {files.length
            ? files.map((file, index) => (
                <React.Fragment key={index}>
                  {file}
                  <br />
                  <br />
                </React.Fragment>
              ))
            : 'Add File'}
        </label>

        <input
          type="file"
          name={name}
          multiple="multiple"
          onChange={handleChange}
          className={styles.uploadPhoto}
          id={btoa('upload-photo-' + name)}
        />
      </div>
      <div>
        <p
          style={{
            margin: 0,
            padding: 0,
            paddingTop: 4,
            fontSize: 12,
            fontWeight: 500,
            fontStyle: 'italic',
          }}
        >
          Allowed Types: {allowed}
          {isRequired && (
            <span style={{ color: '#d32f2f', padding: 0 }}>*</span>
          )}
        </p>
      </div>

      <ErrorMessage name={name} parent={parent} />
    </div>
  );
}
